import type { PersonaStarter } from '../lib/personas';

interface StarterChipsProps {
  starters: ReadonlyArray<PersonaStarter>;
  onPick: (prompt: string) => void;
}

/**
 * Suggestion chips shown above ChatInput after onboarding completes,
 * until the user sends their first message of the session.
 *
 * Visually lighter than QuickReplies — these are optional starters, not
 * required selections. Tapping a chip calls onPick with the chip's full
 * prompt text (which may differ from the chip label, e.g. label
 * "What's for tea?" -> prompt "What's for tea tonight?").
 */
export function StarterChips({ starters, onPick }: StarterChipsProps) {
  if (starters.length === 0) return null;
  return (
    <div
      role="group"
      aria-label="Conversation starters"
      className="flex flex-wrap gap-2 px-3 pt-3 pb-1"
    >
      {starters.map((s) => (
        <button
          key={s.label}
          type="button"
          onClick={() => onPick(s.prompt)}
          className="rounded-full border border-moor-200 bg-cream-50 px-3 py-1.5 text-xs font-medium text-moor-700 transition-colors hover:bg-moor-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-moor-500/40 focus-visible:ring-offset-2"
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
